import { createContext } from "react";

export const PLPSContext = createContext(null);
